import { styled } from '@clickcease/cc-client-components-lib'

export const TagInstallationConatiner = styled('div', {
  padding: '$20',
})

export const TagInstallationFooter = styled('div', {
  position: 'absolute',
  bottom: '0',
  left: '0',
  display: 'flex',
  justifyContent: 'flex-end',
  width: '740px',
  padding: '$10 $20',
})
